import { render, staticRenderFns } from "./Iris.vue?vue&type=template&id=7a14caa9&"
import script from "./Iris.vue?vue&type=script&lang=js&"
export * from "./Iris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Iris.vue"
export default component.exports